export default __webpack_public_path__ + "static/media/discord.e1a3a521.svg";